import { Button } from '@cian/ui-kit/button';

import { cropPhone, formatPhone } from './utils';

export interface ICroppedPhoneProps {
  phone: string;
  isCropped: boolean;
  onClick(): void;
}

export function CroppedPhone({ phone, isCropped, onClick }: ICroppedPhoneProps) {
  return (
    <Button type="button" theme="fill_secondary" size="XS" onClick={onClick}>
      {isCropped ? cropPhone(phone) : formatPhone(phone)}
    </Button>
  );
}
